(function () {
  if (window.__cpArriendo) return;
  window.__cpArriendo = true;

  function observe(root) {
    var els = (root || document).querySelectorAll('.cp-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function countUp(root) {
    (root || document).querySelectorAll('[data-cp-count]:not([data-done])').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-cp-count'));
      if (isNaN(target)) return;
      el.setAttribute('data-done', '1');
      var start = null, dur = 1400;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        function step(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('es-CL');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  function stickyBar() {
    var bar = document.querySelector('[data-cp-sticky]');
    if (!bar) return;
    var hero = document.querySelector('[data-cp-hero]');
    var form = document.getElementById('cotizar');
    function update() {
      var pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var formVisible = false;
      if (form) {
        var r = form.getBoundingClientRect();
        formVisible = r.top < window.innerHeight && r.bottom > 0;
      }
      bar.classList.toggle('is-visible', pastHero && !formVisible);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init(root) { observe(root); countUp(root); stickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
